module.exports = __webpack_public_path__ + "img/qu_be.18e02f8.jpg";